export const uploadeImage = async(image)=>{
    const formData = new FormData()
    formData.append('image',image)
    const res = await fetch(`https://api.imgbb.com/1/upload?key=8a84f9a0adb6e0f2d0b38385991d112e`,{
        method:'post',
        body:formData
    })
    const data = await res.json()
    return data.data
}